import { revealDesktopAppWindow } from '@/lib/desktop-app-window';

/** Client-side navigation to an internal path, e.g. the App Router's `router.push`. */
export type NavigateToPath = (path: string) => void;

/**
 * Brings the desktop app forward on `path`. Navigation starts before the reveal so a window
 * hidden in the tray is already rendering its destination when it appears. A `null` path only
 * reveals the window.
 */
export async function openInDesktopAppWindow(
  path: string | null,
  navigate: NavigateToPath,
): Promise<void> {
  if (path) {
    navigate(path);
  }
  await revealDesktopAppWindow();
}
